import React from "react";
import { Segmented } from "antd";

const MySegmented = ({ options, value, setValue, className, size = 'middle' }) => {
  return <Segmented size={size} options={options} value={value} onChange={setValue} className={`${className}`} />
};

export default MySegmented;
